// This icon file is generated automatically.
var PPieChartOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M12.5 7.1H6.9V1.5a.13.13 0 00-.12-.13h-.4A6.23 6.23 0 00.13 7.63a6.23 6.23 0 006.25 6.25 6.23 6.23 0 006.25-6.24v-.41a.13.13 0 00-.13-.13zm-2.47 4.2a5.18 5.18 0 11-4.19-8.84v5.7h5.7a5.15 5.15 0 01-1.51 3.15zm3.85-5.08l-.05-.44A6.22 6.22 0 008.2.17L7.76.12a.12.12 0 00-.13.13v6c0 .07.05.13.12.13l6-.02c.07 0 .13-.06.13-.14zm-5.2-.9V1.3a5.2 5.2 0 014.01 4h-4z", "fill-rule": "nonzero" } }] }, "name": "p-pie-chart", "theme": "outlined" };
export default PPieChartOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PPieChartOutlined.js
// module id = 3534
// module chunks = 0